import { Redirect } from "react-router-dom";

export const isImage = (url) => /\.(jpg|jpeg|png|webp|gif|svg|jfif)$/.test(url);

export const isVideo = (url) => /\.(mp4|mov|wmv|avi|flv|f4v|mkv|webm|mp2|mpeg|swf)$/.test(url);

//url for production
export var url = "";
if (process.env.NODE_ENV === "development") {
  url = "";
} else {
  url = window.location.host.split("/")[1];
  if (url) {
    url = `/${window.location.host.split("/")[1]}`;
  } else url = process.env.PUBLIC_URL; /// ADD YOUR CPANEL SUB-URL
}

//Function to validate and return errors for a form
export const checkForm = (formData) => {
  let errorState = {};
  Object.keys(formData).forEach((item) => {
    if (formData[item] === null || formData[item] === "") {
      errorState[item] = "This field is required";
    }
  });
  return errorState;
};

export const checkFormData = (formData) => {
  let errorState = {}, length = 0;
  Object.keys(formData).forEach((item) => {
    if (formData[item] === null || formData[item] === "" || formData[item]===undefined) {
      errorState[item] = "This field is required";
      length++;
    }
  });
  const isValid = length===0 ? true : false;
  return {errors:errorState,isValid};
};

//Function that returns the first or first two letters from a name
// export const findUpper = (string) => {
//   let extractedString = [];

//   for (var i = 0; i < string.length; i++) {
//     if (string.charAt(i) === string.charAt(i).toUpperCase() && string.charAt(i) !== " ") {
//       extractedString.push(string.charAt(i));
//     }
//   }
//   if (extractedString.length > 1) {
//     return extractedString[0] + extractedString[1];
//   } else {
//     return extractedString[0];
//   }
// };

export const findUpper = (string) => {
  let str = string.split(" ",2);  
  if (str.length > 1) {
    return str[0].charAt(0).toUpperCase() + str[1].charAt(0).toUpperCase();
  } else {
    return str[0].charAt(0).toUpperCase();
  }
};

//Function that calculates the from current date
export const setDeadline = (days) => {
  let todayDate = new Date();
  var newDate = new Date(todayDate);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
};

// Function to structure date ex : 20-11-2011;
export const formattedDate = (_date) => {
  let rdate = new Date(_date).toLocaleDateString("en-CA").split("-").reverse().join("-");
  return rdate;
};
export const formattedDateTime = (_date) => {
  let rdate = new Date(_date).toLocaleDateString("en-CA").split("-").reverse().join("-");
  const rtime = new Date(_date).toLocaleTimeString();
  return rdate+" "+" "+rtime;
};

export const formattedDate2 = (_date) => {
  let rdate = new Date(_date);
  let d = rdate.getDate();
  d < 10 && (d = "0" + d);
  let m = rdate.getMonth() + 1;
  m < 10 && (m = "0" + m);
  let y = rdate.getFullYear();
  rdate = d + "-" + m + "-" + y;

  return rdate;
};

// Function to structure date ex : Jun 4, 2011;
export const getDateStructured = (date) => {
  let d = date.getDate();
  let m = date.getMonth();
  let y = date.getFullYear();
  let final = monthNames[m] + " " + d + ", " + y;
  return final;
};

// Function to structure date ex: YYYY-MM-DD
export const setDateForPicker = (rdate) => {
  let d = rdate.getDate();
  d < 10 && (d = "0" + d);
  let m = rdate.getMonth() + 1;
  m < 10 && (m = "0" + m);
  let y = rdate.getFullYear();
  rdate = y + "-" + m + "-" + d;

  return rdate;
};

// Set deadlines for projects
export const setDeadlineDays = (deadline) => {
  var currentDate = new Date();
  var difference = deadline.getTime() - currentDate.getTime();
  var days = Math.ceil(difference / (1000 * 3600 * 24));
  return days;
};

//Date formatter function
export const dateFormatterAlt = (date, reverse) => {
  let d = date.getDate();
  let m = date.getMonth();
  let y = date.getFullYear();
  reverse ? (date = m + "-" + d + "-" + y) : (date = y + "-" + d + "-" + m);
  return date;
};

//Date formatter function
export const dateFormatter = (date, reverse, string) => {
  var dateformat = date.split("-");
  //var date = dateformat[1]+"-"+dateformat[2]+"-"+dateformat[0];
  reverse
    ? (date = dateformat[2] + "-" + dateformat[0] + "-" + dateformat[1])
    : (date = dateformat[1] + "-" + dateformat[2] + "-" + dateformat[0]);

  return date;
};

//todays Date
export const todaysDate = new Date();

//current Time
export const currentTime = () => {
  var hours = todaysDate.getHours();
  var minutes = todaysDate.getMinutes();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime = hours + ":" + minutes + " " + ampm;
  return strTime;
};

//Percentage calculation
export const calcPercentage = (str1, str2) => {
  let result = Number(str2) / Number(str1);
  result = result * 100;
  return Math.floor(result);
};

export const truncate = (str, n) => {
  return str.length > n ? str.substr(0, n - 1) + " " + truncate(str.substr(n - 1, str.length), n) : str;
};

export const RedirectAs404 = ({ location }) => (
  <Redirect to={Object.assign({}, location, { state: { is404: true } })} />
);

// returns upload url
export const getUploadParams = () => {
  return { url: "https://httpbin.org/post" };
};

export const bulkActionOptions = [
  { value: "suspend", label: "Suspend User" },
  { value: "delete", label: "Delete User" },
];

// Converts KB to MB
export const bytesToMegaBytes = (bytes) => {
  let result = bytes / (1024 * 1024);
  return result.toFixed(2);
};

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
